import React from "react";
import PropTypes from "prop-types";
import Plus from "./img/plus.svg";
import Minus from "./img/minus.svg";
import "./style.scss";

export class Zoom extends React.Component {
  scaleDown = () => {
    const val = this.props.scale - 0.1;

    if (val >= 1) {
      //Save scale state:
      this.props.setSceneScale({
        scale: val,
      });
    }
  };

  scaleUp = () => {
    const val = this.props.scale + 0.1;

    if (val <= 2.1) {
      //Save scale state:
      this.props.setSceneScale({
        scale: val,
      });
    }
  };

  render() {
    return (
      <div id="zoom">
        <button
          onClick={this.scaleDown}
          disabled={this.props.scale > 1 ? null : "true"}
        >
          <span>Zoom out</span>
          <img src={Minus} aria-label={"Zoom out"} />
        </button>
        <p>{parseInt(this.props.scale * 100) + "%"}</p>
        <button
          onClick={this.scaleUp}
          disabled={this.props.scale < 2 ? null : "true"}
        >
          <span>Zoom in</span>
          <img src={Plus} aria-label={"Zoom in"} />
        </button>
      </div>
    );
  }
}

Zoom.propTypes = {
  scale: PropTypes.number,
  setSceneScale: PropTypes.func,
};
